import "../../styles/product-detail.css";
import Footer from "../../components/footer";
import Header from "../../components/header";

function EBudget() {
  return (
    <div>
      <Header />
      <div className="product-details">
        <div className="details-heading">
          <h1>e-Budget</h1>
          <p>Budget & Project Monitoring System</p>
        </div>
        <div className="details-body">
          <p>
            eBudget is a suite of Budget & Project Monitoring System developed
            by BrandOne Technologies Ltd. It is a web web-based Budget & Project
            management system that eases budget planning, preparations
            implementation and tracking process. It is also used to determine
            the performance of budget.
          </p>
        </div>
        <div className="details-features">
          <p>
            With eBudget, various private and public sectors can perform the
            following:
          </p>
          <ol>
            <li>
              <p>Monitor Budget performance in real-time mode</p>
            </li>
            <li>
              <p>
                Monitor Budget sub-heads centrally by the budgets department
              </p>
            </li>
            <li>
              <p>Secure Budgets records</p>
            </li>
            <li>
              <p>
                Generate intelligent budget, contract and project performance
                reports
              </p>
            </li>
            <li>
              <p>
                Conduct a robust value analysis for contracts or projects in
                line with extant provisions such as PPP framework, BPP
                requirements, global Industry best practice for value assurance
                review.
              </p>
            </li>
          </ol>
        </div>
        <div className="details-features">
          <p>
            Below is some of the <span>key features</span> of the solution:
          </p>
          <ol>
            <li>
              <p>Multi-Project planning and monitoring.</p>
            </li>
            <li>
              <p>Scenario planning.</p>
            </li>
            <li>
              <p>Deadline alerts.</p>
            </li>
            <li>
              <p>Budgeting & forecasting.</p>
            </li>
            <li>
              <p>Collaborative workspace.</p>
            </li>
            <li>
              <p>Contract Administration.</p>
            </li>
            <li>
              <p>Project planning.</p>
            </li>
            <li>
              <p>Project tracking.</p>
            </li>
            <li>
              <p>Project budgeting.</p>
            </li>
            <li>
              <p>Periodic reporting.</p>
            </li>
            <li>
              <p>Transaction monitoring.</p>
            </li>
            <li>
              <p>Planning tools.</p>
            </li>
            <li>
              <p>Budget control.</p>
            </li>
            <li>
              <p>Activity monitoring.</p>
            </li>
          </ol>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EBudget;
